import { styled } from '@mui/material/styles';
import { Typography, Paper } from '@mui/material';

const PREFIX = 'ContactFormInstructions';

const classes = {
  container: `${PREFIX}-container`,
  section: `${PREFIX}-section`,
};

const Root = styled(Paper)(({ theme }) => ({
  [`&.${classes.container}`]: {
    backgroundColor: 'rgba(1, 16, 18, 0.04)',
    padding: theme.spacing(2),
    width: 564,
    marginLeft: 12,
    marginRight: 'auto',
    overflowY: 'auto',
  },
  [`& .${classes.section}`]: {
    textDecoration: 'underline',
    fontWeight: 600,
  },
}));

export default function ContactFormInstructions() {
  return (
    <Root className={classes.container}>
      <Typography mt={2} mb={2} variant="h4">
        Support for this page
      </Typography>
      <Typography variant="h6" className={classes.section}>
        Owner
      </Typography>
      <Typography variant="h6">
        Please provide us with the Owner's name and contact information.
      </Typography>
      <Typography variant="h6" className={classes.section} mt={2}>
        Billing
      </Typography>
      <Typography variant="h6">
        Please provide us with the contact information for your company's
        billing department.
      </Typography>
      <Typography variant="h6" className={classes.section} mt={2}>
        Dispatch
      </Typography>
      <Typography variant="h6">
        Please provide us with the contact information for your company's
        dispatch.
      </Typography>
      <Typography variant="h6" className={classes.section} mt={2}>
        Messaging
      </Typography>
      <Typography variant="h6">
        To fully utilize this platform, communications will be sent to you and
        any drivers for pertinent items or issues. Please help us understand the
        best mode of communication for you and your drivers.
      </Typography>
    </Root>
  );
}
